import React, {useMemo} from "react";
import {Link, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {RouteDefine} from "../../routes/RouteDefine";
import {isSettingsPath} from "../../routes/settingsPaths";
import {useSetupSummary} from "../../common/hooks/useSetupSummary";
import {getVisibleSyncNavItems} from "../../common/helpers/syncNavModules";

const Navbar: React.FC = () => {
    const location = useLocation();
    const urlPath = location.pathname;
    const {t} = useTranslation();
    const {setup, isV2} = useSetupSummary();

    const visibleSyncItems = useMemo(
        () => getVisibleSyncNavItems(setup),
        [setup],
    );

    const integrationNavActive = visibleSyncItems.some((item) => item.route === urlPath);
    const integrationNavTarget = visibleSyncItems[0]?.route ?? RouteDefine.dashboard;

    return (
        <React.Fragment>
            <div className="app-menu navbar-menu">
                <div id="scrollbar">
                    <div className="container-fluid">
                        <ul className="navbar-nav" id="navbar-nav">
                            <li className="nav-item">
                                <Link
                                    to={RouteDefine.dashboard}
                                    className={`nav-link menu-link menu-link-ams fs-14${RouteDefine.dashboard === urlPath ? " active" : ""}`}
                                >
                                    {t("common.navbar.dashboard")}
                                </Link>
                            </li>
                            {visibleSyncItems.length > 0 ? (
                                <li className="nav-item">
                                    <Link
                                        className={`nav-link menu-link menu-link-ams${integrationNavActive ? " active" : ""}`}
                                        to={integrationNavTarget}
                                    >
                                        <span data-key="t-home" className="fs-14">
                                            {t("common.navbar.integrationManagement")}
                                        </span>
                                    </Link>
                                    <div className="menu-dropdown p-0">
                                        <ul className="nav nav-sm flex-column">
                                            {visibleSyncItems.map((item) => (
                                                <li
                                                    key={item.key}
                                                    className={`nav-item${urlPath === item.route ? " active" : ""}`}
                                                >
                                                    <Link
                                                        className="nav-link fs-14 justify-content-center bd-bottom"
                                                        to={item.route}
                                                    >
                                                        {t(item.labelKey)}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>
                            ) : null}
                            <li className="nav-item">
                                <Link
                                    to={RouteDefine.settings}
                                    className={`nav-link menu-link menu-link-ams fs-14${isSettingsPath(urlPath) ? " active" : ""}`}
                                >
                                    {t("common.navbar.settings")}
                                </Link>
                            </li>
                            {isV2 ? (
                                <li className="nav-item">
                                    <Link
                                        to={RouteDefine.help}
                                        className={`nav-link menu-link menu-link-ams fs-14${urlPath === RouteDefine.help ? " active" : ""}`}
                                    >
                                        {t("common.navbar.help")}
                                    </Link>
                                </li>
                            ) : null}
                        </ul>
                    </div>
                </div>
                <div className="sidebar-background"/>
            </div>
        </React.Fragment>
    );
};

export default Navbar;
